import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditMatchListGroupPayload } from '@app-store/slices/matchListGroups/edit'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditMatchListGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchListGroups.edit

function* editMatchListGroupSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/companies/match-list-groups/${payload.matchListGroupId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Match list group updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editMatchListGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editMatchListGroupSagaTask)
}

export default editMatchListGroupSaga
